import React, { useState, useEffect } from "react";
import Loader from "../../../components/ui/Loader/Loader";
import CurrencyFormatter from "../../../services/CurrencyFormatter";
import HttpAPICall from "../../../services/HttpAPICall";
import { INVENTORY_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import { DisplayListPagination } from "../../../components/TapUi";
import { useSelector } from "react-redux";

const ConsumptionHistoryContent = ({ itemData, warehouse_id, asset_id, workstation_id,employee_id,sub_assembly_id }) => {
    const [consumtionHistoryList, setConsumtionHistoryList] = useState([]);
    const [consumptionDetailLoading, setConsumptionDetailLoading] = useState(false);
    const [itemName, setItemName] = useState("");
    const [itemCode, setItemCode] = useState("");
    const [listing_tbl_page, setListingTblPage] = useState(1);
    const [listingMeta, setListingMeta] = useState(null);
    const [totalListingCount, setTotalListingCount] = useState(0);
    
    const access_token = useSelector(state => state.auth.access_token);

    const fetchConsumptionHistoryData = (page = 1) => {
        setConsumptionDetailLoading(true);
        setConsumtionHistoryList([]);
        setListingTblPage(page);
        
        let params = {
            search_workstation_ids: workstation_id ? [workstation_id] : [],
            search_sub_assembly_ids : sub_assembly_id ? [sub_assembly_id] : [],
            search_employee_ids : employee_id ? [employee_id] : [],
            search_item_ids: itemData ? [itemData.id] : [],
            search_warehouse_ids: warehouse_id ? [warehouse_id] : [],
            page: page,
            for_report: 'N',
            search_asset_ids: asset_id ? [asset_id] : []
        };

        HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/report/item-wise-consumption',
            access_token, params, {}, (resp) => {
                let respData = resp.data;
                setConsumtionHistoryList(respData.data);
                setItemName(itemData ? itemData.name : '');
                setItemCode(itemData ? itemData.item_code : '');
                setListingMeta(respData);
                setTotalListingCount(respData.total);
            }).finally(() => setConsumptionDetailLoading(false));
    };

    useEffect(() => {
        if (itemData) {
            fetchConsumptionHistoryData();
        }
    }, [itemData]);

    if (consumptionDetailLoading) return <Loader />;

    return (
        <div>
            <div className='p-1 bg-light border-bottom'>
                <table className='table table-sm mb-0 table-borderless text-sm'>
                    <tbody>
                        <tr>
                            <td style={{ width: "15%" }}>Item</td>
                            <th>{itemName || "-"}</th>
                        </tr>
                        <tr>
                            <td style={{ width: "15%" }}>Item Code</td>
                            <th>{itemCode || "-"}</th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style={{ maxHeight: "330px", overflowY: "auto", marginTop: "8px", marginBottom:"8px"}}>
                <table className="table table-bordered table-sm align-middle bg-white mt-2 table-fixed"  >
                    <thead className="table-secondary ">
                        <tr>
                            <th className='text-center' style={{ width: "12%" }}>Transaction Date</th>
                            <th className='text-center' style={{ width: "10%" }}>Transaction ID</th>
                            <th className="text-center" style={{ width: "22%" }}>Warehouse</th>
                            <th className="text-center" style={{ width: "20%" }}>Consumption for</th>
                            <th style={{ width: "8%" }}>Status</th>
                            <th style={{ width: "6%" }}>Qty</th>
                            <th style={{ width: "8%" }}>Amount</th>
                            <th style={{ width: "15%" }}>Counterlog</th>
                        </tr>
                    </thead>
                    <tbody>
                        {consumtionHistoryList.length > 0 ? consumtionHistoryList.map((rowData, k) => (
                            <tr key={k}>
                                <td className='text-center'>{rowData.transaction_date_display}</td>
                                <td className='text-center'>{rowData.transaction_id}</td>
                                <td>{rowData.warehouse_name}</td>
                                <td>
                                    {rowData.consumption_type == 'asset' && rowData.assetProfile?.name}
                                    {rowData.consumption_type == 'workstation' && rowData.workstation?.workstation_name}
                                    {rowData.consumption_type == 'employee' && rowData.employee?.display_full_name}
                                    {rowData.consumption_type == 'sub_assembly' && rowData.subAssembly?.name}
                                    ({rowData.consumption_type == 'asset' ? 'Asset' : rowData.consumption_type == 'workstation' ? 'Workstation' : rowData.consumption_type == "sub_assembly" ? 'Sub Assembly' : "Employee"})
                                </td>
                                <td>{rowData.status?.name || "-"}</td>
                                <td className="text-center">{rowData.qty}</td>
                                <td className="text-center">
                                    <CurrencyFormatter amount={rowData.amount} />
                                </td>
                                <td className="text-end">
                                    {rowData.assetCounterlog?.length > 0 ? rowData.assetCounterlog.map(cl =>
                                        <div key={cl.id}>{cl.label}: {cl.reading} {cl.unit}</div>
                                    ) : "NA"}
                                </td>
                            </tr>
                        )) : (
                            <tr><td colSpan="8" className="text-center">No Record Found</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
            <DisplayListPagination
                meta={listingMeta}
                onPageChange={(e) => fetchConsumptionHistoryData(e.selected + 1)}
            />
        </div>
    );
};

export default ConsumptionHistoryContent;